import { render, staticRenderFns } from "./SearchArea.vue?vue&type=template&id=3bb7ee4c&scoped=true"
import script from "./SearchArea.vue?vue&type=script&lang=js"
export * from "./SearchArea.vue?vue&type=script&lang=js"
import style0 from "./SearchArea.vue?vue&type=style&index=0&id=3bb7ee4c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb7ee4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bb7ee4c')) {
      api.createRecord('3bb7ee4c', component.options)
    } else {
      api.reload('3bb7ee4c', component.options)
    }
    module.hot.accept("./SearchArea.vue?vue&type=template&id=3bb7ee4c&scoped=true", function () {
      api.rerender('3bb7ee4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trans/SearchArea.vue"
export default component.exports